import { render, staticRenderFns } from "./root-dirs.vue?vue&type=template&id=416d7119"
import script from "./root-dirs.vue?vue&type=script&lang=js"
export * from "./root-dirs.vue?vue&type=script&lang=js"
import style0 from "./root-dirs.vue?vue&type=style&index=0&id=416d7119&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports